export default __webpack_public_path__ + "static/media/SH3.89f5d826.jpg";